import type { FC, ReactNode } from 'react';
import { Outlet } from 'react-router-dom';
import { Box } from '@mui/material';
import { experimentalStyled } from '@mui/material/styles';
import { MainNavbar } from './MainNavbar';
import { Footer } from './Footer';

interface PublicLayoutProps {
    children?: ReactNode;
    customTitle?: string;
}

const PublicLayoutRoot = experimentalStyled('div')(({ theme }) => ({
    backgroundColor: theme.palette.background.default,
    paddingTop: 64,
}));

export const PublicLayout: FC<PublicLayoutProps> = ({ children, customTitle }) => {
    return (
        <PublicLayoutRoot>
            <MainNavbar showMenu={false} customTitle={customTitle} />
            <Box sx={{ minHeight: '80vh' }}>{children || <Outlet />}</Box>
            <Footer />
        </PublicLayoutRoot>
    );
};
